<div class="w-100 h-100 d-flex flex-column align-items-start wrapper animated fadeIn position-relative">
	<button class="btn btn-close d-flex" data-test-id="close-button" (click)="close.emit()">Close</button>
	<button type="button" data-test-id="btn-back" class="btn btn-back" (click)="openTotalSavingPanel.emit()">Back</button>
	<div data-test-id="header" class="header d-flex align-items-center justify-content-between w-100">
		<h2 class="title mb-0" data-test-id="title">Savings graph</h2>
		<div class="toggle">
			<button class="btn" [class.active]="view.isActive" (click)="toggleView(view)" *ngFor="let view of views">
				{{ view.value }}
			</button>
		</div>
	</div>
	<div class="chart-wrapper" data-test-id="chart-wrapper">
		<div class="filters d-flex">
			<mat-checkbox color="primary" [formControl]="workloadShownControl">
				<span class="filters__toggle">Show workload drop tolerance</span>
			</mat-checkbox>
			<div class="d-flex align-items-center ml-3">
				<span class="filters__legend filters__legend--green" [class.disabled]="workloadShownControl.disabled"></span>
				<span class="filters__legend-title ml-2">Zesty tolerance</span>
			</div>
			<div class="d-flex align-items-center ml-3">
				<span class="filters__legend filters__legend--red" [class.disabled]="workloadShownControl.disabled"></span>
				<span class="filters__legend-title ml-2">Saving Plans tolerance</span>
			</div>
		</div>
		<ng-container *ngIf="chartUpdatedOption; else loading">
			<div class="chart" echarts [options]="chartUpdatedOption" [merge]="chartUpdatedOption" data-test-id="chart"></div>
		</ng-container>
	</div>
</div>

<ng-template #loading>
	<app-spinner data-test-id="loading-spinner"></app-spinner>
</ng-template>
